// web/src/console/sections/ConversationView.tsx
import type { JSX } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { consoleApi } from "../../lib/consoleApi";
import { useAsync } from "../useAsync";
import { ReadonlyChat } from "../ReadonlyChat";

export function ConversationView(): JSX.Element {
  const { sessionId = "" } = useParams();
  const [params] = useSearchParams();
  const focusKey = params.get("focus");
  const navigate = useNavigate();
  const { data, loading, error, reload } = useAsync(() => consoleApi.fetchConversation(sessionId), [sessionId]);
  if (loading) return <div className="cc-skeleton" style={{ height: 240 }} />;
  if (error || !data) return <div className="cc-empty">加载失败。 <button className="cc-back" onClick={reload}>重试</button></div>;
  const turns = data.turns;
  const firstUser = turns.find((t) => t.role === "user");
  const title = firstUser && firstUser.role === "user" && firstUser.text ? firstUser.text : sessionId;
  return (
    <>
      <button className="cc-back" onClick={() => navigate(-1)}>返回</button>
      <div className="cc-card" style={{ marginTop: 12 }}>
        <div className="cc-card-title">会话</div>
        <div className="cc-chat-title">{title}</div>
      </div>
      <div className="cc-card" style={{ marginTop: 12 }}>
        {turns.length === 0 ? <div className="cc-empty">暂无消息</div> : <ReadonlyChat turns={turns} focusKey={focusKey} />}
      </div>
    </>
  );
}
